import type { CreateSavedFilterBody, SavedFilter } from '@tasks/contracts';
import { apiRequestList, apiRequestResource, apiRequestVoid } from './client';

export function listSavedFilters(signal?: AbortSignal): Promise<SavedFilter[]> {
  return apiRequestList<SavedFilter>('/filters', { signal });
}

export function createSavedFilter(body: CreateSavedFilterBody): Promise<SavedFilter> {
  return apiRequestResource<SavedFilter>('/filters', 'filter', { method: 'POST', body });
}

export function updateSavedFilter(id: string, body: CreateSavedFilterBody): Promise<SavedFilter> {
  return apiRequestResource<SavedFilter>(`/filters/${encodeURIComponent(id)}`, 'filter', {
    method: 'PATCH',
    body,
  });
}

export function deleteSavedFilter(id: string): Promise<void> {
  return apiRequestVoid(`/filters/${encodeURIComponent(id)}`, { method: 'DELETE' });
}
